export const PATHWAY_KEYS = {
  all: ['pathway'] as const,
  presets: () => [...PATHWAY_KEYS.all, 'presets'] as const,
} as const;
